import { API_ORIGIN } from "@/lib/api";
import { getMemberToken } from "@/lib/auth";
import type { GameItem } from "@/lib/types";

/**
 * 게임은 서버가 서비스하는 «독립 페이지»다.
 * react-router 로 옮기지 않고 같은 창에서 전체화면으로 이동한다.
 * (window.open · target="_blank" 는 안드로이드 WebView 에서 막히므로 쓰지 않는다)
 *
 * 회원 토큰을 ?t= 로 넘겨야 점수가 기록된다. 안 넘기면 아무도 랭킹에 못 올라간다.
 * 토큰 키는 로그인 코드가 실제로 쓰는 키를 그대로 가져온다 (getMemberToken).
 */
export function gameHref(game: Pick<GameItem, "url">): string {
  const raw = game.url || "";
  const path = raw.startsWith("/") ? raw : `/${raw}`;
  const token = getMemberToken() ?? "";
  const back =
    typeof window !== "undefined"
      ? window.location.pathname + window.location.search
      : "/";
  return `${API_ORIGIN}${path}?t=${encodeURIComponent(token)}&back=${encodeURIComponent(back)}`;
}

/**
 * 화면에서 숨길 게임 코드.
 * 서버(games.php) 목록은 그대로 두고, 노출되는 자리(메인 섹션·/games·명예의 전당 탭)에서만 제외한다.
 * 다시 보이게 하려면 이 배열에서 코드를 빼면 된다.
 */
const HIDDEN_GAME_CODES = ["jump"];

/** 숨김 대상 게임을 걸러낸 목록. 카드 개수를 고정하지 않고 서버가 준 만큼만 남긴다. */
export function visibleGames<T extends { code: string }>(list: T[]): T[] {
  return list.filter((g) => !HIDDEN_GAME_CODES.includes(g.code));
}

/** 점수를 «12,300» 형태로. 문자열로 와도 안전하게 처리한다. */
export function formatScore(score: number | string | undefined | null): string {
  const n = Number(score ?? 0);
  return Number.isFinite(n) ? n.toLocaleString() : "0";
}